import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { useId, useState } from 'react';

type JobAttributionListItemProps = {
  kindName: string;
  title: string;
  description?: string | null;
};

/** Item de atribuição do cargo; expande para mostrar a descrição quando houver. */
export function JobAttributionListItem({
  kindName,
  title,
  description,
}: JobAttributionListItemProps) {
  const [expanded, setExpanded] = useState(false);
  const contentId = useId();
  const trimmedDescription = description?.trim() ?? '';
  const canExpand = trimmedDescription.length > 0;

  return (
    <li className="rounded-lg border border-secondary-200">
      {canExpand ? (
        <button
          type="button"
          className="flex w-full items-start gap-2 px-3 py-2 text-left transition-colors hover:bg-secondary-50"
          aria-expanded={expanded}
          aria-controls={contentId}
          onClick={() => setExpanded((current) => !current)}
        >
          <div className="min-w-0 flex-1">
            <div className="text-xs font-medium uppercase tracking-wide text-primary-600">
              {kindName}
            </div>
            <div className="font-medium text-secondary-900">{title}</div>
          </div>
          <ChevronDownIcon
            className={`mt-1 h-4 w-4 shrink-0 text-secondary-500 transition-transform ${
              expanded ? 'rotate-180' : ''
            }`}
            aria-hidden
          />
        </button>
      ) : (
        <div className="px-3 py-2">
          <div className="text-xs font-medium uppercase tracking-wide text-primary-600">
            {kindName}
          </div>
          <div className="font-medium text-secondary-900">{title}</div>
        </div>
      )}

      {canExpand && expanded ? (
        <div id={contentId} className="border-t border-secondary-100 px-3 py-2">
          <p className="whitespace-pre-wrap text-sm text-secondary-600">{trimmedDescription}</p>
        </div>
      ) : null}
    </li>
  );
}
